import useCustomizableCloset from "@hooks/use-customizable-closet";
import ClosetItemsList from "@components/core/ClosetItemsList";
import ClosetValidationCompleteSubHeader from "../DrawerClosetRTC/ClosetValidationCompleteSubHeader";

function DrawerClosetInPreparationRecap({ setStep }) {
  const currentCloset = useCustomizableCloset();

  return (
    <div>
      <ClosetValidationCompleteSubHeader setStep={setStep} />

      <div className="m-2">
        <ClosetItemsList closet={currentCloset} />
      </div>
    </div>
  );
}

export default DrawerClosetInPreparationRecap;
